export default __webpack_public_path__ + "static/media/stripe-down-mobile.17835cef.svg";